<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout align-center>
      <v-flex sm12 md4 hidden-xs-only order-xs1>
        <SvgAnim viewBox="650 90 320 320" class="floor"></SvgAnim>        
      </v-flex>
      <v-flex xs12 md8 text-xs-center>
        <p class="modulo animated fadeInLeft dura-1"><span class="wrapper wrapper-1"><span class="numero_modulo">M1</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 1:</span> Aspectos generales y marco regulatorio</span></p>
        <p class="modulo animated fadeInLeft dura-2"><span class="wrapper wrapper-2"><span class="numero_modulo">M2</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 2:</span> Clasificación de las reservas</span></p>
        <p class="modulo animated fadeInLeft dura-3"><span class="wrapper wrapper-3"><span class="numero_modulo">M3</span></span>&nbsp;<span class="texto_modulo"><span class="titulo_modulo">Módulo 3:</span> Métodos de estimación</span></p>
      </v-flex>
    </v-layout>    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Presentacion/AUDIO 05'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgAnim from '../../assets/Modulo 1/diapositiva-14'
export default {
  components: {
    SvgAnim
  },
  data() {
    return {
      dialogos: [
        "El curso está ordenado en tres módulos." 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
<style lang="scss" scoped>
.modulo {
  display: inline-block;
}
.texto_modulo {
  flex: 1 1 70%;
  text-align: left;
  display: inline-block;
  color: black;
  font-family: helveticaNeueCn;
  font-weight: bold;
  padding: 5px;
  font-size: 1.2rem;
  padding-left: 2.2rem;
  position: relative;
  left: -2rem;
  width: 500px;
  max-width: calc(100vw - 70px);
  line-height: 1em;
  z-index: 1;
  top: -0.2em;
  &::before, &::after {
    z-index: -1;
    position: absolute;
    content: " ";
    display: block;
    top: 0;
    left: 0;
    height: 100%;
    width: 0;
    background-color: white;
    transition: width 200ms;
  }
  &::before {
    background-color: #F9DB14;
    width: 100%;
  }
  @media (max-width: 960px) and (orientation: portrait) {
    font-size: 1rem;
  }
}

.wrapper {
  padding: 20px;
  display: inline-block;
  border-radius: 100%;
  background-size: 100% 100%;
  &.wrapper-1{
    background-image: url('../../assets/textura-M1.png');
  }
  &.wrapper-2{
    background-image: url('../../assets/textura-M2.png');
  }
  &.wrapper-3{
    background-image: url('../../assets/textura-M3.png');
  }
}

.numero_modulo {
  flex: 1 0;
  position: relative;
  z-index: 2;
  background-color: #004535;
  border: 2px solid white;
  border-radius: 100%;
  padding-top: 0.5em;
  font-size: 1.2em;
  display: inline-block;
  width: 2.3em;
  height: 2.3em;
  max-width: 2.3em;
  max-height: 2.3em;
  text-align: center;
  color: white;
}

.titulo_modulo {
  color: #004535;
}

.floor {
  border-bottom: 3px solid gray;
}
</style>
